let audioCtx = null;

const getOrCreateContext = () => {
	if (!audioCtx || audioCtx.state === 'closed') {
		audioCtx = new (window.AudioContext || window.webkitAudioContext)();
	}
	return audioCtx;
};

// Call on user interaction (e.g. the audio toggle button) to unlock autoplay
export const ensureAudioReady = async () => {
	try {
		const ctx = getOrCreateContext();
		if (ctx.state === 'suspended') {
			await ctx.resume();
		}
	} catch {
		// ignore
	}
};

// Play a short two-tone alert chime
export const playAlert = async () => {
	try {
		const ctx = getOrCreateContext();
		if (ctx.state === 'suspended') {
			await ctx.resume();
		}
		if (ctx.state !== 'running') return;

		const osc = ctx.createOscillator();
		const gain = ctx.createGain();
		osc.connect(gain);
		gain.connect(ctx.destination);

		osc.type = 'sine';
		osc.frequency.setValueAtTime(880, ctx.currentTime);
		osc.frequency.setValueAtTime(660, ctx.currentTime + 0.15);

		gain.gain.setValueAtTime(0, ctx.currentTime);
		gain.gain.linearRampToValueAtTime(0.35, ctx.currentTime + 0.05);
		gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.45);

		osc.start(ctx.currentTime);
		osc.stop(ctx.currentTime + 0.45);
	} catch {
		// Audio is supplemental — silently ignore failures
	}
};
